import { useEffect } from "react";

const SITE = "https://app.angiolini.kz";

const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
};

// Держит title/description/canonical/robots в актуальном состоянии при
// клиентской навигации. Статический HTML для роботов формирует scripts/prerender.js.
export function useSeo({ title, description, canonical, noindex = false, image } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', { name: "description" }).setAttribute("content", description);
      upsertMeta('meta[property="og:description"]', { property: "og:description" }).setAttribute("content", description);
    }
    if (title) {
      upsertMeta('meta[property="og:title"]', { property: "og:title" }).setAttribute("content", title);
    }
    if (image) {
      upsertMeta('meta[property="og:image"]', { property: "og:image" }).setAttribute("content", image);
    }
    const href = canonical ? (canonical.startsWith("http") ? canonical : SITE + canonical) : null;
    if (href) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", href);
      upsertMeta('meta[property="og:url"]', { property: "og:url" }).setAttribute("content", href);
    } else if (noindex) {
      // Не оставляем canonical предыдущей страницы на закрытом разделе
      document.head.querySelector('link[rel="canonical"]')?.remove();
    }
    upsertMeta('meta[name="robots"]', { name: "robots" })
      .setAttribute("content", noindex ? "noindex,follow" : "index,follow,max-image-preview:large");
  }, [title, description, canonical, noindex, image]);
}

export default useSeo;
